import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Response} from '@angular/http';
import {AlertService, DataUtils, EventManager, JhiLanguageService} from 'ng-jhipster';

import {AccesBnbaccess, AdresseBnbaccess, HebergementBnbaccess, PreferenceUser} from './hebergement-bnbaccess.model';
import {HebergementBnbaccessService} from './hebergement-bnbaccess.service';
import {Observable} from 'rxjs/Observable';

@Component({
    selector: 'jhi-hebergement-bnbaccess-dialog',
    templateUrl: './hebergement-bnbaccess-dialog.component.html'
})
export class HebergementBnbaccessDialogComponent implements OnInit {

    hebergement: HebergementBnbaccess;
    authorities: any[];
    isSaving: boolean;
    categoriesAcces: string[];
    typesAcces: string[];
    sensOuverture: string [];
    typesOuvertures: string[];

    constructor(private jhiLanguageService: JhiLanguageService,
                private dataUtils: DataUtils,
                private alertService: AlertService,
                private hebergementService: HebergementBnbaccessService,
                private eventManager: EventManager,
                private route: ActivatedRoute,
                private router: Router) {
        this.jhiLanguageService.setLocations(['hebergement']);
        this.initHebergement();
    }

    ngOnInit() {

        this.route.params
            .map(params => params['id'])
            .flatMap(id => id ? this.hebergementService.find(id) : Observable.of(this.hebergement))
            .subscribe(hebergement => {
                    this.hebergement = hebergement;
                    if (this.hebergement.preferenceUser === null) {
                        this.hebergement.preferenceUser = new PreferenceUser();
                        this.hebergement.preferenceUser.heureDArriveeDePreference = '';
                        this.hebergement.preferenceUser.heureDeDepartDePreference = '';
                    }
                }
            )
        ;

        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.categoriesAcces = ['COMMUN', 'PRIVE'];
        this.typesAcces = ['MONOSTABLE', 'DIGICODE', 'BISTABLE', 'WELOCK'];
        this.sensOuverture = ['GAUCHE', 'DROITE'];
        this.typesOuvertures = ['PREMIERE OUVERTURE', 'A DEJA ETE OUVERTE'];
    }

    private initHebergement() {
        this.hebergement = new HebergementBnbaccess();
        this.hebergement.adresse = new AdresseBnbaccess();
        this.hebergement.preferenceUser = new PreferenceUser();
        this.hebergement.preferenceUser.heureDArriveeDePreference = '';
        this.hebergement.preferenceUser.heureDeDepartDePreference = '';
        this.hebergement.acces = [];
        this.hebergement.droits = [];
    }

    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }

    setFileData($event, hebergement, field, isImage) {
        if ($event.target.files && $event.target.files[0]) {
            let $file = $event.target.files[0];
            if (isImage && !/^image\//.test($file.type)) {
                return;
            }
            this.dataUtils.toBase64($file, (base64Data) => {
                hebergement[field] = base64Data;
                hebergement[`${field}ContentType`] = $file.type;
            });
        }
    }

    addAcces() {
        this.hebergement.acces.push(new AccesBnbaccess());
    }

    removeAcces(acces) {
        this.hebergement.acces.splice(this.hebergement.acces.indexOf(acces), 1);
    }

    navigateToList() {
        this.router.navigate(['hebergement-bnbaccess']);
    }

    save() {
        this.isSaving = true;
        if (this.hebergement.id !== undefined) {
            this.hebergementService.update(this.hebergement)
                .subscribe((res: HebergementBnbaccess) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.hebergementService.create(this.hebergement)
                .subscribe((res: HebergementBnbaccess) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess(result: HebergementBnbaccess) {
        this.eventManager.broadcast({name: 'hebergementListModification', content: 'OK'});
        this.isSaving = false;
        this.navigateToList();
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/hebergement-bnbaccess-dialog.component.ts